import type { MenuProps } from "antd";
import { LineStyle } from "./type-markup";
import { RGBColor } from "react-color";
import type { FilePermissions } from "../pages/FilePage/utils/fileUtils";

export interface FileRecord {
  key: string;
  id?: string;
  name: string;
  format: string;
  version: string;
  system: string;
  discipline?: string;
  type?: string;
  author?: string;
  versionUploadedBy: string;
  owner?: string;
  lastUploaded: string;
  size: string;
  avatar: string;
  permissions?: FilePermissions;
  [key: string]: any;
}

export declare type UniqueIdentifier = string | number;
export type TreeItem<T> = {
  children?: TreeItem<T>[];
  id: UniqueIdentifier;
} & T;

export interface Project {
  projectId: number;
  projectRefId: number | null;
  facilityId: number;
  title: string;
  alias: string;
  created: string;
  updated: string;
  projectStatus: string;
  projectSchema: string;
  status: boolean;
  timezone: string;
  procoreProjectId: number;
  projectInspectionNumber: number;
  projectMarkupsandnotesNumber: number;
  code: string;
  masterformat: string;
  inspectionSpecSectionType: number;
  image: string;
}

export interface ContextMenuState1 {
  visible: boolean;
  x: number;
  y: number;
  records: FileRecord[] | null;
  pageType?: string;
  customMenuItems?: MenuProps["items"];
}

export interface FilterState {
  statuses: string[];
  integrations: string[];
}
export type RenderType = "ssr_session" | "csr_session";
export interface TitleContentDialog {
  title?: string;
  content?: string;
}

export interface ContextMenuState {
  visibleContext: boolean;
  mouseEventContext: React.MouseEvent | null;
  contentContext: React.ReactNode | null;
  contextMenuId: string;
  visibleConfirm: boolean;
  titleContent: TitleContentDialog;
}

export type ResultConfirm = "cancel" | "yes" | "no";

export interface Pagination {
  page: number;
  pageCount: number;
  pageSize: number;
  queryCount: number;
  firstRowIndex: number;
  lastRowIndex: number;
}

export const defaultPagingParams = {
  paging: true,
  page: 1,
  pageSize: 20,
};
export enum Layout {
  Full = "full",
  TwoAndTwo = "2And2",
  OneOnTwo = "1On2",
  TwoOnOne = "2On1",
  OneAndTwo = "1And2",
  TwoAndOne = "2And1",
  OneAndOne = "1And1",
  OneOnOne = "1On1",
}

export enum KeyCode {
  num0 = "0",
  num1 = "1",
  num2 = "2",
  num3 = "3",
  num4 = "4",
  num5 = "5",
  num6 = "6",
  num7 = "7",
  num8 = "8",
  num9 = "9",
  F1 = "F1",
  F5 = "F5",
  F12 = "F12",
  F11 = "F11",
  escape = "Escape",
  enter = "Enter",
  equals = "=",
  add = "+",
  p = "p",
  P = "P",
  f = "f",
  F = "F",
  g = "g",
  G = "G",
  a = "a",
  A = "A",
  z = "z",
  Z = "Z",
  y = "y",
  Y = "Y",
  s = "s",
  S = "S",
  m = "m",
  M = "M",
  n = "n",
  N = "N",
  h = "h",
  H = "H",
  o = "o",
  O = "O",
  c = "c",
  C = "C",
  w = "w",
  W = "W",
  v = "v",
  V = "V",
  digit0 = "0",
  subtract = "-",
  minus = "_",
  pageUp = "PageUp",
  pageDown = "PageDown",
  arrowUp = "ArrowUp",
  arrowDown = "ArrowDown",
  arrowLeft = "ArrowLeft",
  arrowRight = "ArrowRight",
  home = "Home",
  end = "End",
  delete = "Delete",
  BackQuote = "Backquote",
  backQuote = "`",
  shift = "Shift",
  ctrl = "Control",
  alt = "Alt",
  meta = "Meta",
  tab = "Tab",
  CapsLock = "CapsLock",
  x = "x",
  X = "X",
  l = "l",
  L = "L",
  r = "r",
  R = "R",
}

export enum ViewType {
  SaveView = 0,
  MarkupView,
}

export interface PayloadView {
  baseFileId: string;
  baseMajorRev?: number;
  baseMinorRev?: number;
  fileLocation?: string;
}

export interface PayloadOriginFile {
  baseFileId: string;
  baseMajorRev: number;
  baseMinorRev: number;
  fileName?: string;
  originalFilePath?: string;
  viewItemParameters?: any;
}

export interface BookmarkCustom {
  id: string;
  rect: Boundary;
  scale: number | string;
  title: string;
  page: number;
}

export enum StatesObjectType {
  REVIT = "REVIT",
  RED = "RED",
  GREEN = "GREEN",
  BLUE = "BLUE",
}

export interface StreamFile {
  filename: string;

  baseFileId: string;

  baseMajorRev: number;

  baseMinorRev: number;

  isChecked: boolean;

  status: any;
  child: StreamFile[];

  isDirectory: boolean;

  createdDate: string;

  cacheStatus: number;
  modelFileId: string;
  id: string;
  originalFilePath: string;
}

export interface UpdateModelIdPayload extends PayloadOriginFile {
  modelFileId?: string;
}

export interface FilesTree {
  _id?: string;
  id: string;
  Id?: string;
  name: string;
  Name?: string;
  bodyInstance?: FilesTree[] | any;
  persistentId?: string;
  type?: number;
  childs?: FilesTree[];
  Childs?: FilesTree[];
}

export interface iStatesObject {
  id: string;
  name: string;
  char: string;
  object: stateObject[];
  states: {
    color: string;
    type: StatesObjectType;
  };
}

export interface stateObject {
  name: string;
  id: number;
}

export const initStatesObjectData: iStatesObject[] = [
  {
    id: "1",
    name: "Red",
    object: [],
    char: "R",
    states: {
      color: "rgb(255, 0, 0)",
      type: StatesObjectType.RED,
    },
  },
  {
    id: "2",
    name: "Green",
    char: "G",
    object: [],
    states: {
      color: "rgb(0, 255, 0)",
      type: StatesObjectType.GREEN,
    },
  },
  {
    id: "3",
    name: "Blue",
    char: "B",
    object: [],
    states: {
      color: "rgb(0, 0, 255)",
      type: StatesObjectType.BLUE,
    },
  },
];

export interface iStatesObjectResponse {
  id: string;
  modelFileId: string;
  stateData: string;
}

export interface SaveView {
  Camera: any;
  CuttingPlane: any;
  Id?: string;
  ModelFileId: string;
  Name: string;
  NodeSetting: string;
  NodesHide: [];
  NodesShow: [];
  SheetId: any;
  createdBy: string;
  createdDate: number;
  drawMode: number;
  explodeMagnitude: number;
  isolateMode: number;
  isolateNodeIds: number[];
  modifiedDate: number;
  thumnail?: string;
  uniqueId?: string;
  viewType: ViewType;
  arrSelected: number[];
  visibilityState: Communicator.VisibilityState;
}

export type ValueProperties = { [key: string]: unknown } | undefined;
export interface MapValueProperties {
  models: ValueProperties[];
  sheets: ValueProperties[];
  views: ValueProperties[];
}

export interface CameraCadView {
  Projection: string;
  definition: string;
  field: string;
}

export interface CadView {
  Id: string;
  Name: string;
  ModelFileId: string;
  isPerspective: boolean;
  originPoint: Communicator.Point3;
  viewDirect: Communicator.Point3;
  upDirect: Communicator.Point3;
  rightDirect: Communicator.Point3;
  viewer3d: any; // not used yet
  hideCategories: {
    catName: string;
    nodeId?: number;
  }[];
  Camera?: CameraCadView;
  // Id: string;
  // IsCameraSet: any;
  // IsCombineState: any;
  // IsCrosssectionSet: any;
  // IsExplosionSet: any;
  // IsGeomFilteringSet: any;
  // IsPMIFilteringSet: any;
  // ModelFileId: string;
  // Name: string;
  // isAnnotationView: string;
}

export interface Views {
  cadViews: CadView[];
  savedViews: SaveView[];
}

export enum PinMarkerType {
  DOC = "DOC",
  RFI = "RFI",
  SUB = "SUB",
  PCI = "PCI",
}

export interface IPinMarkerData {
  type: PinMarkerType;
  nodes: number[];
  objectId: string;
}

export type NameMarkupItem =
  | "MarkupBaseItem"
  | "Arrow"
  | "Circle"
  | "Ellipse"
  | "Line"
  | "Note"
  | "Polygon"
  | "Polyline"
  | "Rectangle"
  | "Freehand"
  | "Text Box"
  | "Callout"
  | "Cloud"
  | "Note Pin"
  | "Pin Marker";

interface AnyProperties {
  [prop: string]: any;
}
export interface LinkedObjectAPI extends AnyProperties {
  _type: PinMarkerType;
  cmicModelId?: string;
  cmicProjGuid?: string;
}

export interface FileInfoResponse extends PayloadView {
  id?: string;
  filename: string;
  streamLocation: string;
  converter?: FormatViewer;
  modelFileId: string;
  creator?: { id: string; name: string };
  cacheSize?: number | string;
  originalSize?: number | string;
  importAssemblyTreeTime?: number | string;
  importTime?: number | string;
  createdDate?: Date | string;
  originalFile?: string;
  multiStream?: boolean;
  isRootModel?: number;
  extraConvertOutput?: string;
  originalFilePath?: string;
  cacheStatus?: number;
  cacheFilename?: string;
}
export interface FileInfo extends FileInfoResponse {
  accountCacheFile?: string;
  viewId: string;
  loadingTime?: number | string;
}

export type FormatViewer = "Hoops" | "Foxit";

export type PanelFocus =
  | "Linked Objects"
  | "Model Tree"
  | "Right Panel"
  | "Property Grid"
  | "Markup Toolbar"
  | "Settings"
  | "Colored State Objects";

export enum DisplayUnits {
  Milimeter = 1,
  Centimeter = 2,
  Meter = 3,
  Feet = 4,
}

export enum PinMarkerColor {
  RED = "#D4380D",
  YELLOW = "#FF9900",
  GREEN = "#389E0D",
  BLUE = "#096DD9",
  WHITE = "#000000",
}

export interface NotepinCategory {
  type: PinMarkerType;
  color: string;
}

export enum NodeVisibility {
  Hidden = 0,
  Intermediate,
  Visible,
}

export enum FileExtension {
  Revit = "rvt",
  IFC = "ifc",
  DWG = "dwg",
  DGN = "dgn",
}

export enum TabTreeViewsKeys {
  Models = "Models",
  Sheets = "Sheets",
  Views = "Views",
  Levels = "Levels",
}

export interface RawFlatTreeNode {
  Id: string; // Id > -100 => real id, otherwise virtual node
  Name: string; // = ComponentName
  Type: TreeNodeType;
  // optional
  PersistentId?: string; // rvt only
  Childs?: string[];
  Parent?: string;
  CategoryName?: string;
  FamilyName?: string;
  TypeName?: string;
  CategoryFamily?: string;
  ModelFileId?: ModelFileId;
}

export interface FlatTreeNode extends RawFlatTreeNode {
  key: string;
}

export enum TreeNodeType {
  Root = -1,
  Normal = 0, // real node
  Category,
  Family,
  Type,
  Component, // real node, leaf node
  Group,
}

export enum SearchOption {
  Default = 0,
  Case,
  Whole,
  Both,
}

export enum TreeGroupBy {
  Category = "category",
  Family = "family",
  Type = "type",
}

type PlaceDragged = "content-viewer" | "file-list";

export interface DragAndDropResult {
  from: ViewId;
  to: ViewId;
  place: PlaceDragged;
}

export interface ViewActive {
  index?: number;
  baseFileId: string | null;
  name?: string;
  viewId: string;
  formatViewer?: FormatViewer;
  parentIdMerge?: string;
  extension: string;
  modelFileId: string;
}

export interface DataDocumentsPdf {
  data: DocumentNode[];
  maxLevel: number;
  arrAllParent: number[];
}

export interface FilesTree {
  _id?: string;
  id: string;
  Id?: string;
  name: string;
  Name?: string;
  bodyInstance?: FilesTree[] | any;
  persistentId?: string;
  type?: number;
  childs?: FilesTree[];
  Childs?: FilesTree[];
}
export interface TreeNode {
  title: string | undefined;
  key: number;
  level: number;
  persistentId?: string;
  type?: number;
  children?: TreeNode[];
}
export interface DocumentNode extends BookmarkNode {
  key: number;
  children: DocumentNode[];
  level: number;
}

export interface FileUpload {
  index: number;
  all: StreamFile[];
}

export enum MarkupToolbarAction {
  DrawLine = 1,
  DrawArrow,
  DrawCircle,
  DrawEllipse,
  DrawRectangle,
  DrawPolygon,
  DrawPolyline,
  DrawSignature,
  DrawText,
  DrawTextBox,
  DrawNote,
  DrawImage,
  DrawStamp,
  DrawDrawing,
  DrawEraser,
  DrawHighlight,
  DrawRectHighlight,
  Undo,
  Redo,
  Save,
  Cancel,
  ShowPolygonInput,
  SelectImageFilePath,
  DrawPolygonCloud,
  DrawArc,
  DrawCallout,
  DrawNotePin3d,
  DrawCloud,
  DrawPinMarker,
  LineSetting,
  FormatSetting,
}
export interface StatePdfCreate {
  pdfUI: PdfUI;
  pdfViewer: PdfViewer;
}

export interface Thumbnail {
  pageIndex: number;
  thumbnail: string;
}

export const KeyStoreGroupBy = "modelTreeGroupBy";

export interface Point {
  x: number;
  y: number;
}
export interface StraightLine {
  startPoint: Point;
  endPoint: Point;
}

export interface MarkupLineFormat {
  lineColor: RGBColor;
  lineWeight: number;
  lineOpacity: number;
  fillColor: RGBColor;
  fillColorOption: boolean;
  startLineShapeType: number;
  endLineShapeType: number;
  lineStyle: LineStyle;
  rect: Rectangle;
  ratio: number;
}

export interface AnnotAttribute extends MarkupLineFormat, MarkupTextFormat {}

export interface MarkupTextFormat {
  textFontSize: number;
  textColor: RGBColor;
  textFontFamily: string;
  textIsBold: boolean;
  textIsItalic: boolean;
  textIsUnderline: boolean;
}

export interface ColorSetting {
  capingGeometryFace: RGBColor;
  capingGeometryLine: RGBColor;
  capingGeometryPlane: RGBColor;
  selectionMeasurement: RGBColor;
  enablePMIOverride: boolean;
  selectionPMI: RGBColor;
}

export interface GeneralSettingState {
  axis: boolean;
  cube: boolean;
  projectionModelDefault: Communicator.Projection;
  xRayOpacity: number;
  ghostingOpacity: number;
  speedZoom: number;
  bimOrbitEnabled: boolean;
  backGroundColor: RGBColor;
  sheetBackGroundColor: RGBColor;
  gradient: boolean;
  gradientColor: RGBColor;
  sheetColor: RGBColor;
  sheetShadow: RGBColor;
  showLineWeight: boolean;
  displayUnit: DisplayUnits;
  precision: number;
}
export interface EffectSetting {
  ambientOcclusion: boolean;
  ambientOcclusionRadius: number;
  antiAliasing: boolean;
  bloom: boolean;
  bloomIntensityScale: number;
  threshold: number;
  silhoutteEdges: boolean;
  reflectionPlane: boolean;
  shadows: boolean;
  interaction: boolean;
  blurSample: number;
}

export interface PointCloudSetting {
  splatSize: number;
  enableSplat: boolean;
  enableEyeLighting: number;
  cloudSplatMode: number;
}

export interface SettingState {
  general: GeneralSettingState;
  effect: EffectSetting;
  color: ColorSetting;
  pointCloud: PointCloudSetting;
  fetchSettingFail?: boolean;
  customSetting: boolean;
}

export interface ConvertOptions {
  convert3DModel: number;
  convert2DSheet: number;
  extractProperties: number;
  childModels: number;
}
